var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7091 20.7091C21.2363 20.1819 21.2363 19.3271 20.7091 18.7999L13.9615 12.0523L20.7091 5.3046C21.2363 4.77739 21.2363 3.92262 20.7091 3.39541C20.1819 2.86821 19.3271 2.86821 18.7999 3.39541L12.0523 10.1431L5.30459 3.39541C4.77739 2.8682 3.92261 2.8682 3.39541 3.39541C2.8682 3.92261 2.8682 4.77739 3.39541 5.30459L10.1431 12.0523L3.39541 18.7999C2.8682 19.3271 2.8682 20.1819 3.39541 20.7091C3.92261 21.2363 4.77739 21.2363 5.30459 20.7091L12.0523 13.9615L18.7999 20.7091C19.3271 21.2363 20.1819 21.2363 20.7091 20.7091Z",
    fill: "#383838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackX);
export default __webpack_public_path__ + "static/media/back-x.8a821dc60ca8192d77fb2d4d1966e4f6.svg";
export { ForwardRef as ReactComponent };